import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ReceiveDirtyLaundry = lazy(() => import('./receive-dirty-laundry.component'));

export function useReceiveDirtyLaundryRoutes() {
    return (
        <Route path='receive_dirty_laundry'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ReceiveDirtyLaundry />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
